'use client';

import type { PageConfigType } from '@/types';
import { BreadcrumbJsonLd, FAQPageJsonLd, ProductJsonLd } from 'next-seo';
const MarketingSEO = ({
  config
}: {
  config: PageConfigType;
}) => {
  return <>
      <BreadcrumbJsonLd useAppDir={true} itemListElements={[{
      position: 1,
      name: 'Home',
      item: 'https://certresource.com'
    }, {
      position: 2,
      name: config.productNameShort,
      item: config.canonicalUrl
    }]} data-sentry-element="BreadcrumbJsonLd" data-sentry-source-file="MarketingSEO.tsx" />
      <ProductJsonLd useAppDir={true} productName={config.productName} images={config.seo.images} description={config.productDescription} brand={config.seo.brand} manufacturerName={config.seo.manufacturerName}
    // manufacturerLogo="https://your-domain.com/logo.png"
    material="Digital Content" slogan={config.seo.slogan} disambiguatingDescription={config.seo.disambiguatingDescription} releaseDate={config.seo.releaseDate} productionDate={config.seo.productionDate} purchaseDate={config.seo.purchaseDate} aggregateRating={{
      ratingValue: config.seo.aggregateRating.ratingValue,
      reviewCount: config.seo.aggregateRating.reviewCount
    }} offers={[{
      ...config.seo.offers,
      hasMerchantReturnPolicy: {
        returnPolicyCategory: 'https://schema.org/RefundService',
        url: 'https://www.certresource.com/return-policy',
        // Link to your return policy page
        returnPolicySeasonalOverride: {
          startDate: '2025-04-01',
          endDate: '2025-06-01',
          returnMethod: 'Email'
        }
      },
      shippingDetails: {
        shippingRate: 'https://schema.org/FreeShipping',
        // Indicating no shipping charges
        shippingDestination: {
          '@type': 'Country',
          'name': 'Worldwide'
        },
        shippingMethod: 'https://schema.org/Download'
      }
    }]} mpn={config.seo.mpn} data-sentry-element="ProductJsonLd" data-sentry-source-file="MarketingSEO.tsx" />
      {config.faqs ? <FAQPageJsonLd useAppDir={true} mainEntity={config.faqs} /> : null}
    </>;
};
export default MarketingSEO;